<template>
  <q-page class="bg-page q-pa-md">
    <div class="container-md">

      <!-- HEADER -->
      <q-card flat bordered class="card q-pa-md q-mb-md">
        <div class="row items-center justify-between">
          <div>
            <div class="text-h6 text-mint text-bold">Преглед по вработени </div>
            <div class="text-caption text-grey-7">
            </div>
          </div>

        </div>
      </q-card>

      <!-- FILTERS -->
      <q-card flat bordered class="card q-pa-md q-mb-md">
        <div class="row q-col-gutter-md items-center">

          <div class="col-12 col-sm-6 col-md-3">
            <q-input
              v-model="filters.from"
              type="date"
              label="Од датум"
              dense
              outlined
              color="mint"
              @update:model-value="applyFilters"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-3">
            <q-input
              v-model="filters.to"
              type="date"
              label="До датум"
              dense
              outlined
              color="mint"
              @update:model-value="applyFilters"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-3">
            <q-select
              v-model="filters.fazaId"
              :options="faziOptions"
              label="Фаза"
              dense
              outlined
              color="mint"
              emit-value
              map-options
              clearable
              @update:model-value="applyFilters"
            />
          </div>

          <div class="col-12 col-sm-6 col-md-3">
            <q-select
              v-model="filters.vrabotenId"
              :options="employeeOptions"
              label="Вработен"
              dense
              outlined
              color="mint"
              emit-value
              map-options
              clearable
              @update:model-value="onEmployeePicked"
            />
          </div>

          
          <div class="col-12 flex justify-center q-gutter-sm">
            <q-btn label="Исчисти" no-caps class="btn-ghost" @click="resetFilters" />
            <q-btn label="Примени" no-caps class="btn-primary" @click="applyFilters" />
          </div>
        </div>
      </q-card>

      <!-- SUMMARY TABLE -->
      <q-card flat bordered class="card q-pa-md">
        <div class="row items-center justify-between q-mb-sm">
          <div class="text-subtitle2 text-mint text-bold"></div>
          <div class="text-caption text-grey-7">
          
          </div>
        </div>

        <q-table
          :data="employeesSummary"
          :columns="summaryColumns"
          row-key="id"
          flat
          dense
          class="modern-table"
          no-data-label="Нема податоци."
          :loading="loading"
          :rows-per-page-options="[10, 20, 50, 0]"
        >
          <template v-slot:body="props">
            <q-tr
              :props="props"
              class="click-row"
              :class="{ 'row-selected': String(filters.vrabotenId) === String(props.row.id) }"
              @click="openDetails(props.row)"
            >
              <q-td key="name" :props="props">
                <div class="row items-center">
                  <q-icon name="person" color="mint" class="q-mr-sm" />
                  <div class="text-weight-medium">{{ props.row.name }}</div>
                </div>
              </q-td>

             
              <q-td key="totalPhases" :props="props" align="right">
                {{ props.row.totalPhases }}
              </q-td>

              <q-td key="action" :props="props" align="center">
                  <q-btn
                    flat
                    dense
                    size="sm"
                    no-caps
                    class="btn-preview"
                    @click.stop="openDetails(props.row)"
                  >
                    Преглед
                  </q-btn>
                </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-card>

      <!-- DETAILS POPUP -->
      <q-dialog v-model="details.open" persistent>
        <q-card style="width: 1100px; max-width: 98vw;" class="q-pa-md">
          <div class="row items-center justify-between q-mb-sm">
            <div class="text-subtitle1 text-mint text-bold">
             {{ details.employeeName }}
            </div>
            <q-btn flat dense round icon="close" color="grey" @click="details.open = false" />
          </div>

          <!-- <div class="text-caption text-grey-7 q-mb-md">
            Период:
            <b>{{ filters.from || "—" }}</b> до <b>{{ filters.to || "—" }}</b>
            <span class="q-mx-sm">•</span>
            Фаза:
            <b>{{ filters.fazaId ? (faziMap[String(filters.fazaId)] || filters.fazaId) : "Сите" }}</b>
          </div> -->

          <q-table
            :data="details.rows"
            :columns="detailsColumns"
            row-key="key"
            flat
            dense
            class="modern-table"
            no-data-label="Нема фази за овој вработен според филтрите."
            :loading="details.loading"
            :rows-per-page-options="[10, 20, 50, 0]"
          >
            <template v-slot:body-cell-BaranjeID="props">
              <q-td align="center">{{ formatBrojID(props.row.BaranjeID) }}</q-td>
            </template>

            <template v-slot:body-cell-Faza="props">
              <q-td align="center">
                <q-badge outline color="mint">{{ props.row.Faza }}</q-badge>
              </q-td>
            </template>

            <template v-slot:body-cell-Predviden="props">
              <q-td align="center">{{ props.row.Predviden ? formatDisplayDate(props.row.Predviden) : "" }}</q-td>
            </template>

            <template v-slot:body-cell-Start="props">
              <q-td align="center">{{ props.row.Start ? formatDisplayDate(props.row.Start) : "" }}</q-td>
            </template>

            <template v-slot:body-cell-Vreme="props">
        <q-td align="center">
          {{ props.row.Vreme != null ? String(props.row.Vreme).replace('.', ',') : "" }}
        </q-td>
      </template>

            <template v-slot:body-cell-End="props">
              <q-td align="center">{{ props.row.End ? formatDisplayDate(props.row.End) : "" }}</q-td>
            </template>
          </q-table>
        </q-card>
      </q-dialog>

    </div>
  </q-page>
</template>

<script>
import api from "@/api";
import { getVraboteniAPI } from "@/services/vraboteniAPI";
import { loadBaranjaAPI } from "@/services/baranjaAPI";

export default {
  name: "IzvestajVraboteni",

  data() {
    return {
      loading: false,

      filters: {
        from: null,
        to: null,
        fazaId: null,
        vrabotenId: null
      },

      employeeOptions: [],
      employeeMap: {},

      faziOptions: [],
      faziMap: {},

      aplikaciiMap: {},

      baranjaBase: [],
      phasesByBaranje: {},

      employeesSummary: [],

      summaryColumns: [
        { name: "name", label: "Вработени", field: "name", align: "left", sortable: true },
        { name: "totalPhases", label: "Вкупно фази", field: "totalPhases", align: "right", sortable: true },
        { name: "action", label: "", field: "action", align: "center" }
      ],

      details: {
        open: false,
        loading: false,
        employeeId: null,
        employeeName: "",
        rows: []
      },

      detailsColumns: [
        { name: "BaranjeID", label: "Број", field: "BaranjeID", align: "center", sortable: true },
        { name: "Firma", label: "Фирма", field: "Firma", align: "left", sortable: true },
        { name: "Aplikacija", label: "Апликација", field: "Aplikacija", align: "center", sortable: true },
        { name: "Faza", label: "Фаза", field: "Faza", align: "center", sortable: true },
        { name: "Predal", label: "Предал", field: "Predal", align: "center" },
        { name: "Predviden", label: "Предвиден", field: "Predviden", align: "center", sortable: true },
        { name: "Start", label: "Почеток", field: "Start", align: "center", sortable: true },
        { name: "End", label: "Крај", field: "End", align: "center", sortable: true },
        { name: "Vreme", label: "Време", field: "Vreme", align: "center", sortable: true },
        { name: "Zabeleska", label: "Забелешка", field: "Zabeleska", align: "left" }
      ]
    };
  },

  methods: {
    // ---------- helpers ----------
    formatBrojID(v, len = 8) {
      if (v == null) return "";
      const raw = String(v).includes("/") ? String(v).split("/")[0] : String(v);
      const digits = raw.replace(/\D/g, "");
      if (!digits) return "";
      return digits.padStart(len, "0");
    },

    formatDisplayDate(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}.${mm}.${yyyy}`;
    },

    parseAnyTime(v) {
      if (!v) return null;
      const d = new Date(v);
      const t = d.getTime();
      return isNaN(t) ? null : t;
    },

   toISODate(value) {
  if (!value) return "";

  const str = String(value).trim();

  if (str.includes("T")) return str.split("T")[0];
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return str;

  const parts = str.split(" ");
  const datePart = parts[0];
  const [day, mon, year2] = datePart.split("-");

  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12"
  };

  const mm = months[mon];
  if (!mm) return "";

  const yyyy = year2 && year2.length === 2 ? `20${year2}` : year2;
  if (!day || !yyyy) return "";

  return `${yyyy}-${mm}-${day}`;
},
    // ---------- API loaders ----------
    async loadVraboteni() {
      const list = await getVraboteniAPI();
      const arr = Array.isArray(list) ? list : [];

      this.employeeMap = Object.fromEntries(arr.map(v => [String(v.SifraID), v.Naziv]));
      this.employeeOptions = arr
        .map(v => ({ label: v.Naziv, value: v.SifraID }))
        .sort((a, b) => String(a.label).localeCompare(String(b.label), "mk"));
    },

   async loadAplikacii() {
  try {
    const res = await api.get("/aplikacii");
    const data = res.data;

    this.aplikaciiMap = Object.fromEntries(
      (Array.isArray(data) ? data : []).map(a => [a.SifraID, a.Opis])
    );
  } catch (e) {
    console.error("Грешка при вчитување апликации:", e);
    this.aplikaciiMap = {};
  }
},

    async loadFazi() {
  try {
    const res = await api.get("/get/fazi");
    const data = res.data;

    const arr = Array.isArray(data) ? data : [];
    this.faziOptions = arr.map(f => ({ label: f.Opis, value: f.SifraID }));
    this.faziMap = Object.fromEntries(arr.map(f => [String(f.SifraID), f.Opis]));
  } catch (e) {
    console.error("Грешка при вчитување фази:", e);
    this.faziOptions = [];
    this.faziMap = {};
  }
},

    async fetchAllFazi(baranjeId) {
  try {
    const res = await api.get("/baranja/get-faza", {
      params: { BaranjeID: baranjeId }
    });

    const data = res.data;
    const list = Array.isArray(data) ? data : [];

    const mapped = list.map((f) => {
      const zabeleskaVal =
        (f?.Zabeleska ?? f?.zabeleska ?? f?.ZabeleskaText ?? f?.ZabeleskaOpis ?? "") || "";

      const fazaID = f.FazaID ? Number(f.FazaID) : null;
      const predalId = f.PredalVrabID != null ? Number(f.PredalVrabID) : null;
      const primilId = f.PrimilVrabID != null ? Number(f.PrimilVrabID) : null;

      return {
        pkid: Number(f.pkid) || 0,
        FazaID: fazaID,
        FazaText: this.faziMap[String(fazaID)] || String(fazaID || ""),
        PredalName: this.employeeMap[String(predalId)] || "",
        PrimilID: primilId,
        Predviden: this.toISODate(f.DatumPredviden),
        Start: this.toISODate(f.DatumPocetok),
        End: this.toISODate(f.DatumKraj),
        Casovi: f.Vreme === "" || f.Vreme == null ? null : Number(f.Vreme),
        Zabeleska: zabeleskaVal
      };
    });

    mapped.sort((a, b) => (Number(a.pkid) || 0) - (Number(b.pkid) || 0));
    return mapped;
  } catch (e) {
    console.error("fetchAllFazi error", e);
    return [];
  }
},

    async loadBaranjaAndCachePhases() {
  const apiData = await loadBaranjaAPI();
  const arr = Array.isArray(apiData)
    ? apiData
    : (apiData?.Items || apiData?.List || []);

  this.baranjaBase = arr.map(item => ({
    ID: item.ID,
    NazivPartner: item.NazivPartner || "",
    AplikacijaID: item.AplikacijaID,
    OpisAplikacija: item.OpisAplikacija || ""
  }));

  const lists = await Promise.all(
    this.baranjaBase.map(async (b) => {
      const fazi = await this.fetchAllFazi(b.ID);
      return { id: b.ID, fazi };
    })
  );

  this.phasesByBaranje = {};
  lists.forEach(x => {
    this.phasesByBaranje[String(x.id)] = x.fazi || [];
  });
},

   
    onEmployeePicked() {
      this.applyFilters();
    },

    applyFilters() {
      const fromT = this.filters.from ? this.parseAnyTime(this.filters.from) : null;
      const toT = this.filters.to ? this.parseAnyTime(this.filters.to) : null;
      const fazaId = this.filters.fazaId ? Number(this.filters.fazaId) : null;

      const phaseInRange = (p) => {
        const t = this.parseAnyTime(p.Start || p.Predviden);
        if (t == null) return false;
        if (fromT != null && t < fromT) return false;
        if (toT != null && t > toT) return false;
        return true;
      };

      // count по Примил (кај кој е фазата)
      const counts = {}; // empId -> count

      this.baranjaBase.forEach((b) => {
        const phases = this.phasesByBaranje[String(b.ID)] || [];
        phases.forEach((p) => {
          if (!p.PrimilID) return;

          if ((fromT != null || toT != null) && !phaseInRange(p)) return;
          if (fazaId != null && Number(p.FazaID) !== fazaId) return;

          const empId = Number(p.PrimilID);
          counts[empId] = (counts[empId] || 0) + 1;
        });
      });

      
      const selectedEmp = this.filters.vrabotenId ? Number(this.filters.vrabotenId) : null;

      const baseList = selectedEmp
        ? this.employeeOptions.filter(o => Number(o.value) === selectedEmp)
        : this.employeeOptions;

      this.employeesSummary = baseList
        .map(opt => ({
          id: opt.value,
          name: opt.label,
          totalPhases: counts[Number(opt.value)] || 0
        }))
        .sort((a, b) => b.totalPhases - a.totalPhases);
    },

   
    openDetails(row) {
      this.details.open = true;
      this.details.loading = true;
      this.details.employeeId = row.id;
      this.details.employeeName = row.name;
      this.details.rows = [];

      const empId = Number(row.id);
      const fromT = this.filters.from ? this.parseAnyTime(this.filters.from) : null;
      const toT = this.filters.to ? this.parseAnyTime(this.filters.to) : null;
      const fazaId = this.filters.fazaId ? Number(this.filters.fazaId) : null;

      const phaseInRange = (p) => {
        const t = this.parseAnyTime(p.Start || p.Predviden);
        if (t == null) return false;
        if (fromT != null && t < fromT) return false;
        if (toT != null && t > toT) return false;
        return true;
      };

      const rows = [];

      this.baranjaBase.forEach((b) => {
        const phases = this.phasesByBaranje[String(b.ID)] || [];

        phases.forEach((p) => {
       
          if (Number(p.PrimilID) !== empId) return;

         
          if (fazaId != null && Number(p.FazaID) !== fazaId) return;

        
          if ((fromT != null || toT != null) && !phaseInRange(p)) return;

          const aplText =
            b.OpisAplikacija ||
            this.aplikaciiMap[b.AplikacijaID] ||
            b.AplikacijaID ||
            "";

          rows.push({
            key: `${b.ID}-${p.pkid}`,
            BaranjeID: b.ID,
            Firma: b.NazivPartner || "",
            Aplikacija: aplText,
            Faza: p.FazaText || "",
            Predal: p.PredalName || "",
            Predviden: p.Predviden || "",
            Start: p.Start || "",
            End: p.End || "",
            Vreme: p.Casovi,
            Zabeleska: p.Zabeleska || ""
            
          });
        });
      });

      rows.sort((a, b) => {
        const aB = Number(a.BaranjeID) || 0;
        const bB = Number(b.BaranjeID) || 0;
        if (aB !== bB) return aB - bB;
        const aT = this.parseAnyTime(a.Start || a.Predviden) || 0;
        const bT = this.parseAnyTime(b.Start || b.Predviden) || 0;
        return aT - bT;
      });

      this.details.rows = rows;
      this.details.loading = false;
    },

    // ---------- actions ----------
    resetFilters() {
      this.filters = { from: null, to: null, fazaId: null, vrabotenId: null };
      this.applyFilters();
    },

    async reloadFromApi() {
      this.loading = true;
      try {
        await Promise.all([this.loadAplikacii(), this.loadVraboteni(), this.loadFazi()]);
        await this.loadBaranjaAndCachePhases();
        this.applyFilters();
      } finally {
        this.loading = false;
      }
    }
  },

  async mounted() {
    await this.reloadFromApi();
  }
};
</script>

<style scoped>
.bg-page { background: #f9fbfa; min-height: 100vh; }
.container-md { max-width: 1100px; margin: 0 auto; }
.text-mint { color: #0e6b5f; }

.card {
  background: #fff;
  border: 1px solid #e6efed;
  border-radius: 14px;
}

.btn-primary {
  background: #0e6b5f !important;
  color: #fff !important;
  border-radius: 10px !important;
  padding: 0 16px !important;
}
.btn-outline {
  background: #fff !important;
  color: #0e6b5f !important;
  border: 1px solid #0e6b5f !important;
  border-radius: 10px !important;
  padding: 0 16px !important;
}
.btn-ghost {
  background: #f4f8f7 !important;
  color: #0e6b5f !important;
  border: 1px solid #e6efed !important;
  border-radius: 10px !important;
  padding: 0 16px !important;
}

.modern-table thead tr {
  background: #f4f8f7;
  color: #0e6b5f;
  font-weight: 700;
}

.click-row { cursor: pointer; }
.click-row:hover { background: #f6fdfb; }
.row-selected { background: #f1f6f5; }
.btn-preview{
  background:#ffffff !important;
  color:#0e6b5f !important;
  border-radius:8px;
  padding:2px 10px !important;
  font-size:12px;
  min-height:28px;
  box-shadow:none !important;
}
</style>